// Helpers
import { getUrlWithVariant } from '@shopify/theme-product-form';
import { formatMoney } from '@shopify/theme-currency';
import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import { sectionRendering } from 'scripts/helpers/iamota-shopify-ajax';

// Styles
import './_main-product.scss';
import './_yotpo.scss';
var PRODUCT_ROOT = '[data-section-type="product"]';
var PRODUCT_ACCORDION = '.product-accordion.js-accordion';
var ACCORDION_BUTTON = '.js-accordion__button';
var accordionRenderTokens = new WeakMap();
function updateProductAccordion(iamProductForm, variant) {
  var _iamProductForm$datas, _currentAccordion$que;
  var productRoot = iamProductForm === null || iamProductForm === void 0 ? void 0 : iamProductForm.closest(PRODUCT_ROOT);
  var currentAccordion = productRoot === null || productRoot === void 0 ? void 0 : productRoot.querySelector(PRODUCT_ACCORDION);
  var sectionId = iamProductForm === null || iamProductForm === void 0 || (_iamProductForm$datas = iamProductForm.dataset) === null || _iamProductForm$datas === void 0 ? void 0 : _iamProductForm$datas.sectionId;
  if (!productRoot || !currentAccordion || !sectionId || !(variant !== null && variant !== void 0 && variant.id)) return;
  var currentOpenKey = (_currentAccordion$que = currentAccordion.querySelector("".concat(ACCORDION_BUTTON, ".is-open"))) === null || _currentAccordion$que === void 0 || (_currentAccordion$que = _currentAccordion$que.dataset) === null || _currentAccordion$que === void 0 ? void 0 : _currentAccordion$que.productAccordionKey;
  var renderToken = (accordionRenderTokens.get(iamProductForm) || 0) + 1;
  accordionRenderTokens.set(iamProductForm, renderToken);
  sectionRendering.fetch(sectionId, getUrlWithVariant(window.location.pathname, variant.id)).then(sections => {
    if (accordionRenderTokens.get(iamProductForm) !== renderToken) return;
    var nextSectionMarkup = sections === null || sections === void 0 ? void 0 : sections[sectionId];
    if (!nextSectionMarkup) return;
    var parsedDocument = new DOMParser().parseFromString(nextSectionMarkup, 'text/html');
    var nextAccordion = parsedDocument.querySelector(PRODUCT_ACCORDION);
    if (!nextAccordion) return;
    currentAccordion.replaceWith(nextAccordion);
    var preferredButton = currentOpenKey ? nextAccordion.querySelector("".concat(ACCORDION_BUTTON, "[data-product-accordion-key=\"").concat(currentOpenKey, "\"]")) : null;
    var buttonToOpen = preferredButton || nextAccordion.querySelector(ACCORDION_BUTTON);
    if (buttonToOpen && !buttonToOpen.classList.contains('is-open')) {
      buttonToOpen.click();
    }
  }).catch(error => {
    console.error('main-product: Error updating accordion for variant change:', error);
  });
}
iamotaEventHandler.subscribe('productForm:variant:changed', _ref => {
  var iamProductForm = _ref.iamProductForm,
    variant = _ref.variant;
  updateProductAccordion(iamProductForm, variant);
  updateAfterpatyMessaging(iamProductForm, variant);
}, {
  source: "main-product.js"
});
document.addEventListener('click', e => {
  var _squarePlacement$shad;
  if (!(e.target instanceof Element)) return;
  if (!e.target.closest('[data-afterpay-modal-trigger]')) return;
  var squarePlacement = document.querySelector('square-placement');
  console.log('[afterpay] square-placement el:', squarePlacement);
  console.log('[afterpay] shadowRoot:', squarePlacement === null || squarePlacement === void 0 ? void 0 : squarePlacement.shadowRoot);
  var modalBtn = squarePlacement === null || squarePlacement === void 0 || (_squarePlacement$shad = squarePlacement.shadowRoot) === null || _squarePlacement$shad === void 0 ? void 0 : _squarePlacement$shad.querySelector('#logo-link, .afterpay-link');
  console.log('[afterpay] modal btn:', modalBtn);
  modalBtn === null || modalBtn === void 0 || modalBtn.click();
});
function updateAfterpatyMessaging(iamProductForm, variant) {
  var _window$theme;
  var productRoot = iamProductForm === null || iamProductForm === void 0 ? void 0 : iamProductForm.closest(PRODUCT_ROOT);
  var amountEl = productRoot === null || productRoot === void 0 ? void 0 : productRoot.querySelector('[data-afterpay-amount]');
  if (!amountEl || !(variant !== null && variant !== void 0 && variant.price)) return;
  var installment = Math.round(variant.price / 4);
  amountEl.textContent = formatMoney(installment, (_window$theme = window.theme) === null || _window$theme === void 0 ? void 0 : _window$theme.settingCurrencyFormat);
}